var map = {
	"./blockchain.svg": "5433",
	"./check_circle.svg": "dcc3",
	"./codes.svg": "e8e5",
	"./e-commerce.svg": "c56a",
	"./feature_1.svg": "e949",
	"./feature_2.svg": "be2b",
	"./feature_3.svg": "cfc2",
	"./fin-tech.svg": "6e69",
	"./fmcg.svg": "680f",
	"./game-devs.svg": "7a91",
	"./list_arrow.svg": "52e7",
	"./list_check.svg": "757e",
	"./mob-apps.svg": "73d6",
	"./saas-paas.svg": "7df2",
	"./sms.svg": "f35f",
	"./soft-devs.svg": "3efa",
	"./spam-it.svg": "b06c",
	"./spam.svg": "2f39",
	"./startups.svg": "4144",
	"./telegram.svg": "14ac",
	"./viber.svg": "2b6e",
	"./whatsapp.svg": "bdf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";